import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { Docsector } from 'src/app/models/obs/docsector';
import { Sector } from 'src/app/models/obs/sector';
import { Tier3 } from 'src/app/models/obs/tier3';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { BridgeService } from '../../../../services/util/bridge.service';
import { urlEndPoint } from 'src/app/common';
import { SectorService } from 'src/app/services/obs/sector.service';

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrl: './items.component.scss'
})
export class ItemsComponent implements OnInit {

  URLObs: string = urlEndPoint;
  msg: Message;
  tier3s: Tier3[];
  filteredTier1: any[];
  docsector: Docsector[] = [];
  sector: Sector;

  constructor(
    private sectorService: SectorService,
    private tier3Service: Tier3Service,
    private activedRoute: ActivatedRoute,
    private bridgeService: BridgeService
  ) { }

  ngOnInit() {
    this.initObtainData();
  }

  initObtainData() {
    this.activedRoute.paramMap.subscribe(params => {
      const idSector = params.get('id');
      this.getAllNationalAndSectorialTrends(idSector);
      this.getOneSector(idSector);
      this.getReportSectorial(idSector);
      this.bridgeService.enviarIdSector(idSector);
      this.scrollTier3();
    });
  }

  scrollTier3() {
    // Encuentra el elemento con la clase '.fichas' y llévalo a la vista
    setTimeout(() => {
      const element = document.querySelector('.fichas');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 400);
  }

  getOneSector(idsector: string) {
    this.sectorService.getOne(idsector).subscribe(
      res => {
        this.sector = res['data'];
      }
    )
  }

  getReportSectorial(idsector: string) {
    this.docsector = [];
    this.tier3Service.getSectorialReportBySector(idsector).subscribe(
      async (res: any) => {
        if (res.data) {
          if (Array.isArray(res.data)) {
            this.docsector = res.data;
          } else if (typeof res.data === 'object') {
            this.docsector = [res.data];
          }
        }
      },
      err => { this.msg = err; }
    );
  }

  getAllNationalAndSectorialTrends(idsector: string) {
    this.tier3Service.getAllNationalAndSectorialTrends(idsector).subscribe(
      res => {
        this.tier3s = res['data'];
        const tier3sTier1_5 = this.tier3s.filter(p => p.idtier1 === 5);
        const tier3sTier1_13 = this.tier3s.filter(p => p.idtier1 === 13);
        this.filteredTier1 = [
          { idTier1: 5, tier3: tier3sTier1_5 },
          { idTier1: 13, tier3: tier3sTier1_13 }
        ];
      }
    );
  }

}

